import { axiosInstance } from './api';

/** Вечернее понижение порога выкладки — расписание (AI277, #1556/#1566). */
export interface ThresholdScheduleDto {
  id: number;
  rack_type: string;
  from_hour: number | null;
  hours_before_close: number | null;
  multiplier: number;
  zone: number | null;
  rack: number | null;
  enabled: boolean;
  comment: string;
  rack_name?: string | null;
  zone_name?: string | null;
}
export type ThresholdScheduleWrite = Omit<ThresholdScheduleDto, 'id' | 'rack_name' | 'zone_name'>;

const BASE = '/empty_shelf/threshold_schedule/';

export const listThresholdSchedule = (zoneId: string) =>
  axiosInstance.get<{ results?: ThresholdScheduleDto[] } | ThresholdScheduleDto[]>(BASE, { params: { zone: zoneId, page_size: 200 } })
    .then((r) => (Array.isArray(r.data) ? r.data : (r.data.results ?? [])));
export const createThresholdSchedule = (body: ThresholdScheduleWrite) => axiosInstance.post<ThresholdScheduleDto>(BASE, body);
export const patchThresholdSchedule = (id: number, body: Partial<ThresholdScheduleWrite>) => axiosInstance.patch<ThresholdScheduleDto>(`${BASE}${id}/`, body);
export const deleteThresholdSchedule = (id: number) => axiosInstance.delete(`${BASE}${id}/`);
